(function () {
    'use strict';

    angular.module('itxApp.preCommon').factory('preCommonTimestampSvc', preCommonTimestampSvc);

    function preCommonTimestampSvc() {
        return {
            getTs: _getTs
        };

        /*
         * Función para obtener un timestamp
         */
        function _getTs() {
            var now = new Date();
            var mins = now.getMinutes();
            var quarterHours = Math.round(mins / 15);

            if (quarterHours == 4) {
                now.setHours(now.getHours() + 1);
            }

            var rounded = (quarterHours * 15) % 60;
            now.setMinutes(rounded);
            var res = now.getTime();

            if (inditex) {
                res = inditex.iRegistryTs;
            }

            return res;
        }
    }
})();
